import React, { useState, useRef } from 'react';
import {
  Typography,
  TextField,
  Button,
  ButtonGroup,
  MenuItem,
  RadioGroup,
  Radio,
  FormControlLabel,
  withStyles,
  Paper,
  FormHelperText,
  FormControl,
  Dialog,
  Checkbox,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { FileInput } from 'react-admin';
import RASimpleForm from './RASimpleForm';
import {
  setEndTaskDialog,
  setConfirmationDialog,
  setSnackbar,
  setTaskVerifyAddress,
} from '../redux';
import { updateTask, endTask, getTicketTypesRequiredForImages } from '../../helperFunctions';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import TransferToCellMaterials from './TransferToCellMaterials';
import MaterialsSell from './MaterialsSell';
import CloseReasons from './CloseReasons';
import DocumentsButton from './Documents/DocumentsButton';
import withFocus from '../../WithFocus';
import {
  closeStatuses,
  ticketTypes,
  skipClosingTicketTypes,
  newInstallationTicketTypes,
  ticketTypesCpeReturn,
} from '../../constants';
import Amend from './Amend';
import { ticketTypesInstallation } from './Documents/constants';
import ResetPasswodCard from './ResetPasswodCard';
import { TaskChatButton } from '../../Chat';

const imageInputStyle = {
  root: {
    margin: '0px',
    padding: '0px',
  },
};

const closeReasonsMapping = {
  1: 'Отстраняване на аварии',
  2: 'Оптимизация на сградна мрежа',
  3: 'Оптимизация на магистрална мрежа',
};
const EndTaskDialogContent = props => {
  const { classes } = props;
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const fileInputRefs = useRef({});
  const endTaskDialog = useSelector(state => state.tasks.endTaskDialog);
  const data = useSelector(state => state.tasks.data);
  const state = useSelector(state => state.tasks.data.ticketTypesCloseReasons);
  const [ticketCloseReasons, setTicketCloseReason] = useState();

  const newUsedMaterials = useSelector(state => state.tasks.newUsedMaterials);
  const taskVerifyAddress = useSelector(state => state.tasks.taskVerifyAddress);
  const rejectSignatureRequestDialog = useSelector(
    state => state.tasks.rejectSignatureRequestDialog
  );
  const sellMaterials = useSelector(state => state.tasks.data.sellMaterials) ?? [];
  const selectedSellMaterials = useSelector(state => state.tasks.chechedMaterialsToSell) ?? [];

  const {
    closeStatus,
    itsActivityType,
    itsActivityDescription,
    closeReason,
    closeNote,
    imageInputData,
    videoSurvImageInputData,
    breakdownCloseReason,
    serviceOnAddress,
    isTax,
    taxHours,
    taxMinutes,
    taxNote,
  } = endTaskDialog;

  const setBreakdownCloseReason = newValue => {
    dispatch(setEndTaskDialog({ ...endTaskDialog, breakdownCloseReason: newValue }));
  };

  const task = data.tasks.find(x => x.id === endTaskDialog.taskId);
  const documentsDashboard = task ? task.documentsDashboard : null;
  const getSelectedSellMaterials = () => {
    return sellMaterials
      ? sellMaterials.filter(x => selectedSellMaterials.includes(x.serialNumber))
      : [];
  };

  const calculateShowImageInputs = () => {
    let showImages = false;
    if (task) {
      showImages =
        task.ticketTypeId && getTicketTypesRequiredForImages().includes(task.ticketTypeId);
      const prevTaskIndex = data.tasks.indexOf(task) - 1;
      if (prevTaskIndex >= 0) {
        const prevTask = data.tasks[prevTaskIndex];
        if (prevTask.client || prevTask.address || prevTask.phone) {
          showImages =
            showImages &&
            !(
              task.client === prevTask.client ||
              task.address === prevTask.address ||
              task.phone === prevTask.phone
            );
        } else {
          const prevPrevTaskIndex = data.tasks.indexOf(task) - 2;
          if (prevPrevTaskIndex >= 0) {
            const prevPrevTask = data.tasks[prevTaskIndex];
            showImages =
              showImages &&
              !(
                task.client === prevPrevTask.client ||
                task.address === prevPrevTask.address ||
                task.phone === prevPrevTask.phone
              );
          }
        }
      }
    }
    return showImages;
  };
  const showImageInputs =
    calculateShowImageInputs() || task?.ticketTypeId === ticketTypes.qualityCheck;
  const showVideoSurvImageInputs = task?.isVideoSurv || task?.isVideoImpl;
  const hasTransferToCellMaterials =
    task && newUsedMaterials.filter(x => x.taskAddress === task.address).length > 0;
  const { taskStatuses, itsActivityTypes } = data;

  const fontSize = width <= 500 ? '4vw' : '20px';

  const CloseNoteInput = withFocus(TextField, {
    label: 'Забележка',
    style: { margin: '4px' },
    multiline: true,
    fullWidth: true,
    value: closeNote,
    onChange: x =>
      dispatch(setEndTaskDialog({ ...endTaskDialog, closeNote: x.target.value.replace("'", '"') })),
  });

  const validatе = () => {
    if (task.hasItsService && isTax) {
      if (taxHours < 0 || taxHours > 23) {
        dispatch(
          setSnackbar({
            open: true,
            message: 'Моля, въведете час между 0 и 23',
          })
        );
        return false;
      }

      if (taxMinutes < 0 || taxMinutes > 59) {
        dispatch(
          setSnackbar({
            open: true,
            message: 'Моля, въведете минути между 0 и 59',
          })
        );
        return false;
      }

      if (taxHours === 0 && taxMinutes === 0) {
        dispatch(
          setSnackbar({
            open: true,
            message: 'Моля, въведете часове/минути за таксуване!',
          })
        );
        return false;
      }
    }

    if (
      task.ticketId &&
      !(task.isVideoImpl || task.isVideoSurv || task.isIts) &&
      !task.technology
    ) {
      dispatch(setSnackbar({ open: true, message: 'Избери технология' }));
      return false;
    }
    if (!closeStatus) {
      dispatch(setSnackbar({ open: true, message: 'Избери статус на задачата' }));
      return false;
    }
    if (task.isIts && !itsActivityType) {
      dispatch(setSnackbar({ open: true, message: 'Избери тип на дейността!' }));
      return false;
    }
    if (task.isIts && itsActivityDescription && itsActivityDescription.length > 300) {
      dispatch(
        setSnackbar({
          open: true,
          message: 'Поле Кратко описание не може да съдържа повече от 300 символа!',
        })
      );
      return false;
    }

    if (
      task.ticketTypeId &&
      task.ticketTypeId === 1 &&
      closeStatus === 1 &&
      !breakdownCloseReason
    ) {
      dispatch(setSnackbar({ open: true, message: 'Избери причина за затваряне' }));
      return false;
    }
    if (closeReason === 9 && !closeNote) {
      dispatch(setSnackbar({ open: true, message: 'Попълни забележка' }));
      return false;
    }
    if (closeStatus === 2 && !closeReason) {
      dispatch(setSnackbar({ open: true, message: 'Избери причина за отлагане' }));
      return false;
    }
    if (
      closeStatus === 1 &&
      showImageInputs &&
      imageInputData.find(
        x => x.required && x.value === null && !skipClosingTicketTypes.includes(task?.ticketTypeId)
      )
    ) {
      dispatch(setSnackbar({ open: true, message: 'Прикачи задължителните снимки' }));
      return false;
    }
    if (
      closeStatus === closeStatuses.success &&
      showVideoSurvImageInputs &&
      videoSurvImageInputData.find(
        x => x.required && x.value === null && !skipClosingTicketTypes.includes(task?.ticketTypeId)
      )
    ) {
      dispatch(setSnackbar({ open: true, message: 'Прикачи задължителните снимки' }));
      return false;
    }

    if (
      closeStatus === 1 &&
      task.ticketTypeId &&
      (task.ticketTypeId === ticketTypesCpeReturn.ChangeTechnology ||
        task.ticketTypeId === ticketTypesCpeReturn.InstalationMigration) &&
      task.oldDevices &&
      task.oldDevices.length > 0
    ) {
      dispatch(setSnackbar({ open: true, message: 'Извършете действия за стари CPE устройства!' }));
      return false;
    }

    return true;
  };

  return (
    endTaskDialog.open && (
      <Dialog open={endTaskDialog.open} fullScreen>
        <ButtonGroup style={{ width: '100%', position: 'sticky', top: '0', zIndex: '100' }}>
          <Button
            onClick={() => dispatch(setEndTaskDialog({ ...endTaskDialog, open: false }))}
            variant="contained"
            style={{ width: '50%' }}
          >
            <Typography gutterBottom component="span" style={{ fontSize }}>
              Назад
            </Typography>
          </Button>
          <Button
            onClick={() => {
              if (validatе()) {
                hasTransferToCellMaterials
                  ? endTask({
                      data,
                      taskId: task.id,
                      closeStatus,
                      itsActivityType,
                      isTax,
                      taxHours,
                      taxMinutes,
                      taxNote,
                      itsActivityDescription,
                      closeNote,
                      closeReason,
                      breakdownCloseReason,
                      imageInputData: closeStatus === 1 && showImageInputs ? imageInputData : null,
                      newUsedMaterials,
                      dispatch,
                      endTaskDialog,
                      videoSurvImageInputData:
                        closeStatus === 1 && showVideoSurvImageInputs
                          ? videoSurvImageInputData
                          : null,
                      serviceOnAddress,
                      documentsDashboard,
                      rejectSignatureRequestDialog,
                      sellMaterialsData: getSelectedSellMaterials(),
                    })
                  : dispatch(
                      setConfirmationDialog({
                        open: true,
                        title: [
                          {
                            text:
                              'Не сте попълнили вложени материали. Сигурни ли сте, че искате да затворите задачата?',
                          },
                        ],
                        onConfirm: () =>
                          endTask({
                            data,
                            taskId: task.id,
                            closeStatus,
                            itsActivityType,
                            isTax,
                            taxHours,
                            taxMinutes,
                            taxNote,
                            itsActivityDescription,
                            closeNote,
                            closeReason,
                            breakdownCloseReason,
                            imageInputData:
                              closeStatus === 1 && showImageInputs ? imageInputData : null,
                            newUsedMaterials,
                            dispatch,
                            endTaskDialog,
                            videoSurvImageInputData:
                              closeStatus === 1 && showVideoSurvImageInputs
                                ? videoSurvImageInputData
                                : null,
                            serviceOnAddress,
                            documentsDashboard,
                            rejectSignatureRequestDialog,
                            sellMaterialsData: getSelectedSellMaterials(),
                            ticketCloseReasons,
                          }),
                        onCancel: () =>
                          dispatch(
                            setConfirmationDialog({
                              open: false,
                              title: [],
                              onConfirm: null,
                              onCancel: null,
                            })
                          ),
                      })
                    );
              }
            }}
            variant="contained"
            color="secondary"
            style={{ width: '50%' }}
            disabled={endTaskDialog.isEnding}
          >
            <Typography gutterBottom component="span" style={{ fontSize }}>
              Приключи задача
            </Typography>
          </Button>
        </ButtonGroup>
        {task.addressVerificationUrl && !taskVerifyAddress && (
          <Paper
            style={{
              margin: '3px',
              marginTop: '5px',
              backgroundColor: '#da291c',
              padding: '4px',
            }}
          >
            <Button
              onClick={() => {
                window.open(task.addressVerificationUrl, '_blank');
                dispatch(setTaskVerifyAddress(true));
              }}
              variant="contained"
              fullWidth
            >
              <Typography gutterBottom component="p" style={{ fontSize }}>
                Верифициране на адрес
              </Typography>
            </Button>
          </Paper>
        )}
        <DocumentsButton task={task} />
        <Paper
          style={{ margin: '3px', marginTop: '5px', backgroundColor: '#da291c', padding: '4px' }}
        >
          <Paper style={{ padding: '4px' }}>
            <TextField
              label="Статус на задачата"
              style={{ margin: '4px' }}
              select
              onChange={x =>
                dispatch(setEndTaskDialog({ ...endTaskDialog, closeStatus: x.target.value }))
              }
              fullWidth
              value={closeStatus}
            >
              <MenuItem value={1}>Успешно приключена</MenuItem>
              <MenuItem value={2}>Отложена</MenuItem>
            </TextField>
            {closeStatus === 1 && task.ticketTypeId && task.ticketTypeId === 1 && (
              <CloseReasons
                handleCloseReason={setBreakdownCloseReason}
                closeReason={breakdownCloseReason}
                ticketId={task.ticketId}
              />
            )}
            {closeStatus === 1 &&
              task.manualTicketType &&
              Object.entries(closeReasonsMapping).find(y => y[1] === task.manualTicketType) && (
                <>
                  <TextField
                    label="Причина за закриване"
                    select
                    style={{ margin: '4px' }}
                    onChange={x => {
                      setTicketCloseReason(x.target.value);
                    }}
                    fullWidth
                    value={ticketCloseReasons}
                  >
                    {state
                      .filter(
                        x =>
                          x.code ===
                          Number(
                            Object.entries(closeReasonsMapping).find(
                              y => y[1] === task.manualTicketType
                            )[0]
                          )
                      )
                      .map(x => (
                        <MenuItem key={x.id} value={x.id}>
                          {x.reason}
                        </MenuItem>
                      ))}
                  </TextField>
                </>
              )}
            {closeStatus === 2 && (
              <>
                <TextField
                  label="Причини за отлагане"
                  select
                  style={{ margin: '4px' }}
                  onChange={x =>
                    dispatch(setEndTaskDialog({ ...endTaskDialog, closeReason: x.target.value }))
                  }
                  fullWidth
                  value={closeReason}
                >
                  {taskStatuses
                    .filter(x => x.id !== 0 && x.id !== 1 && x.id !== 2)
                    .map(x => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.name}
                      </MenuItem>
                    ))}
                </TextField>
              </>
            )}
            {CloseNoteInput}
          </Paper>
        </Paper>
        {task.isIts && (
          <Paper
            style={{ margin: '3px', marginTop: '5px', backgroundColor: '#da291c', padding: '4px' }}
          >
            <Paper style={{ padding: '4px' }}>
              <TextField
                label="Тип на дейността"
                style={{ margin: '4px' }}
                select
                onChange={x => {
                  dispatch(
                    setEndTaskDialog({
                      ...endTaskDialog,
                      itsActivityType: x.target.value,
                    })
                  );
                }}
                fullWidth
                value={itsActivityType}
              >
                {itsActivityTypes.map(element => (
                  <MenuItem key={element.id} value={element.id}>
                    {element.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                label="Кратко описание"
                style={{ margin: '4px' }}
                multiline
                fullWidth
                valuе={itsActivityDescription}
                onChange={x =>
                  dispatch(
                    setEndTaskDialog({
                      ...endTaskDialog,
                      itsActivityDescription: x.target.value.replace("'", '"'),
                    })
                  )
                }
              />
            </Paper>
          </Paper>
        )}
        {task.hasItsService && (
          <Paper
            style={{
              margin: '3px',
              marginTop: '5px',
              backgroundColor: '#da291c',
              padding: '4px',
              opacity: task.isClientVipOrVipSla ? 0.5 : 1,
              pointerEvents: task.isClientVipOrVipSla ? 'none' : 'auto',
            }}
            aria-disabled={task.isClientVipOrVipSla}
          >
            <Paper>
              <FormControlLabel
                control={
                  <Checkbox
                    value={isTax}
                    onChange={x => {
                      dispatch(
                        setEndTaskDialog({
                          ...endTaskDialog,
                          isTax: x.target.checked,
                        })
                      );
                    }}
                    color="primary"
                  />
                }
                label="Такса посещение /**опцията не е активнa при клиенти със статус VIP/VIP_SLA**/"
                labelPlacement="start"
              />
              {isTax && (
                <TextField
                  label="Часове"
                  style={{ marginLeft: 32 }}
                  value={taxHours}
                  type="number"
                  inputProps={{
                    step: '1',
                    min: '0',
                    max: '23',
                  }}
                  onChange={x =>
                    dispatch(
                      setEndTaskDialog({
                        ...endTaskDialog,
                        taxHours: x.target.value,
                      })
                    )
                  }
                />
              )}
              {isTax && (
                <TextField
                  label="Минути"
                  style={{ marginLeft: 32 }}
                  value={taxMinutes}
                  type="number"
                  inputProps={{
                    step: '1',
                    min: '0',
                    max: '59',
                  }}
                  onChange={x =>
                    dispatch(
                      setEndTaskDialog({
                        ...endTaskDialog,
                        taxMinutes: x.target.value,
                      })
                    )
                  }
                />
              )}
              {isTax && (
                <TextField
                  label="Забележка"
                  style={{ margin: '8px', width: '98%' }}
                  value={taxNote}
                  type="text"
                  fullWidth
                  onChange={x =>
                    dispatch(
                      setEndTaskDialog({
                        ...endTaskDialog,
                        taxNote: x.target.value,
                      })
                    )
                  }
                />
              )}
            </Paper>
          </Paper>
        )}
        <Paper
          style={{
            margin: '3px',
            marginTop: '5px',
            backgroundColor: task.ticketId ? '#da291c' : '#a5daff',
            padding: '4px',
          }}
        >
          <Typography
            gutterBottom
            component="span"
            style={{ fontSize, color: task.ticketId ? 'white' : 'black', padding: '1px' }}
          >
            Технология
          </Typography>
          {!task.isVideoSurv && !task.isVideoImpl && !task.isIts && (
            <Paper style={{ marginTop: '3px', padding: '8px' }}>
              <FormControl error={task.ticketId && !task.technology}>
                {task.ticketId && !task.technology && <FormHelperText>Задължително</FormHelperText>}
                <RadioGroup>
                  <FormControlLabel
                    checked={task.technology === 'Gpon'}
                    onChange={() => {
                      updateTask(data, task.id, { technology: 'Gpon' }, dispatch);
                    }}
                    value="Gpon"
                    label="GPON"
                    control={<Radio />}
                  />
                  <FormControlLabel
                    checked={task.technology === 'Docsis'}
                    onChange={() => {
                      updateTask(data, task.id, { technology: 'Docsis' }, dispatch);
                    }}
                    value="Docsis"
                    label="DOCSIS"
                    control={<Radio />}
                  />
                  <FormControlLabel
                    checked={task.technology === 'Dth'}
                    onChange={() => {
                      updateTask(data, task.id, { technology: 'Dth' }, dispatch);
                    }}
                    value="Dth"
                    label="DTH"
                    control={<Radio />}
                  />
                </RadioGroup>
              </FormControl>
            </Paper>
          )}
        </Paper>
        {task?.ticketTypeId && newInstallationTicketTypes.includes(task?.ticketTypeId) && (
          <Paper
            style={{
              margin: '3px',
              marginTop: '5px',
              backgroundColor: '#a5daff',
              padding: '4px',
            }}
          >
            <Paper style={{ padding: '4px' }}>
              <TextField
                label="Наличие на текуща услуга на адреса"
                style={{ margin: '4px' }}
                select
                onChange={x =>
                  dispatch(setEndTaskDialog({ ...endTaskDialog, serviceOnAddress: x.target.value }))
                }
                fullWidth
                value={serviceOnAddress}
              >
                <MenuItem value={null} />
                {data.servicesOnAddress.map(x => (
                  <MenuItem key={x.id} value={x.id}>
                    {x.name}
                  </MenuItem>
                ))}
              </TextField>
            </Paper>
          </Paper>
        )}

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {task.ticketId && ticketTypesInstallation.includes(task?.ticketTypeId) ? (
            <Amend ticketId={task.ticketId} />
          ) : (
            <span />
          )}
          <TaskChatButton task={task} />
        </div>

        {showImageInputs && closeStatus === 1 && (
          <Paper style={{ padding: '4px', margin: '3px' }}>
            {imageInputData.map(y => (
              <div key={y.source} style={{ marginBottom: '4px' }}>
                <input
                  type="file"
                  accept="image/jpeg,image/png,image/webp"
                  style={{ display: 'none' }}
                  ref={el => {
                    fileInputRefs.current[y.source] = el;
                  }}
                  onChange={e => {
                    const file = e.target.files && e.target.files[0];
                    const inputEl = fileInputRefs.current[y.source];
                    if (inputEl) inputEl.value = '';
                    if (!file) return;
                    const blobUrl = URL.createObjectURL(file);
                    const img = new Image();
                    img.onload = () => {
                      URL.revokeObjectURL(blobUrl);
                      const canvas = document.createElement('canvas');
                      canvas.width = img.naturalWidth;
                      canvas.height = img.naturalHeight;
                      canvas.getContext('2d').drawImage(img, 0, 0);
                      canvas.toBlob(
                        blob => {
                          if (!blob) {
                            dispatch(
                              setSnackbar({
                                open: true,
                                message:
                                  'Снимката не може да бъде прочетена. Натисни ⋮ → Browse... и избери снимката от галерията.',
                              })
                            );
                            return;
                          }
                          const memFile = new File([blob], file.name || 'image.jpg', {
                            type: 'image/jpeg',
                            lastModified: Date.now(),
                          });
                          const preview = URL.createObjectURL(memFile);
                          const updated = [...imageInputData];
                          updated.splice(updated.indexOf(y), 1, { ...y, value: memFile, preview });
                          dispatch(setEndTaskDialog({ ...endTaskDialog, imageInputData: updated }));
                        },
                        'image/jpeg',
                        0.95
                      );
                    };
                    img.onerror = () => {
                      URL.revokeObjectURL(blobUrl);
                      dispatch(
                        setSnackbar({
                          open: true,
                          message:
                            'Снимката не може да бъде прочетена. Натисни ⋮ → Browse... и избери снимката от галерията.',
                        })
                      );
                    };
                    img.src = blobUrl;
                  }}
                />
                <div
                  onClick={() =>
                    fileInputRefs.current[y.source] && fileInputRefs.current[y.source].click()
                  }
                  style={{
                    // eslint-disable-next-line no-nested-ternary
                    backgroundColor: y.value
                      ? '#acf2ac'
                      : y.required && !skipClosingTicketTypes.includes(task?.ticketTypeId)
                      ? '#da291c'
                      : '#a5daff',
                    padding: '3px',
                    cursor: 'pointer',
                  }}
                >
                  {y.preview ? (
                    <img
                      src={y.preview}
                      alt={y.label}
                      style={{ maxHeight: '120px', maxWidth: '100%', display: 'block' }}
                    />
                  ) : (
                    <Typography>{y.label}</Typography>
                  )}
                </div>
                {y.value && (
                  <Button
                    size="small"
                    onClick={() => {
                      const updated = [...imageInputData];
                      updated.splice(updated.indexOf(y), 1, { ...y, value: null, preview: null });
                      dispatch(setEndTaskDialog({ ...endTaskDialog, imageInputData: updated }));
                    }}
                  >
                    Изчисти
                  </Button>
                )}
              </div>
            ))}
          </Paper>
        )}
        {showVideoSurvImageInputs && closeStatus === closeStatuses.success && (
          <Paper style={{ padding: '4px', margin: '3px' }}>
            <RASimpleForm variant="standard" toolbar={null} cardPadding="0px" margin="none">
              {videoSurvImageInputData.map(y => (
                <FileInput
                  key={y.source}
                  className={classes.root}
                  label=""
                  source={y.source}
                  accept="application/*,image/*"
                  onChange={x => {
                    const storeVideoValue = value => {
                      const updated = [...videoSurvImageInputData];
                      updated.splice(updated.indexOf(y), 1, { ...y, value });
                      dispatch(
                        setEndTaskDialog({ ...endTaskDialog, videoSurvImageInputData: updated })
                      );
                    };
                    if (!(x instanceof Blob)) {
                      storeVideoValue(x);
                      return;
                    }
                    x.arrayBuffer()
                      .then(buf => {
                        const type = x.type || 'application/octet-stream';
                        const name = (x instanceof File && x.name) || 'file';
                        storeVideoValue(
                          new File([new Blob([buf], { type })], name, {
                            type,
                            lastModified: Date.now(),
                          })
                        );
                      })
                      .catch(() => storeVideoValue(x));
                  }}
                  placeholder={
                    <div
                      style={{
                        // eslint-disable-next-line no-nested-ternary
                        backgroundColor: y.value ? '#acf2ac' : y.required ? '#da291c' : '#a5daff',
                        padding: '3px',
                      }}
                    >
                      <Typography>{y.label}</Typography>
                    </div>
                  }
                  fullWidth
                >
                  <></>
                </FileInput>
              ))}
            </RASimpleForm>
          </Paper>
        )}
        {task?.msisdn && (
          <div style={{ margin: '3px' }}>
            <Button
              onClick={() => window.open(task.androidBoxRegistrationUrl, '_blank')}
              variant="contained"
              color="secondary"
              style={{ width: '100%' }}
            >
              <Typography gutterBottom component="span" style={{ fontSize }}>
                Регистрация Android TV
              </Typography>
            </Button>
            <ResetPasswodCard task={task} />
          </div>
        )}
        <div style={{ margin: '3px' }}>
          <TransferToCellMaterials />
        </div>
        <div style={{ margin: '3px' }}>
          <MaterialsSell task={task} hasButtons />
        </div>
      </Dialog>
    )
  );
};

export default withStyles(imageInputStyle)(EndTaskDialogContent);
